<template>
  <div class="sell-apartment-page">
    <div class="content">
      <h1 class="title">Выставить свою квартиру на продажу</h1>
      <p class="subtitle">Свяжитесь с нами удобным способом</p>

      <div class="contacts">
        <!-- WhatsApp кнопка -->
        <a
          href="https://wa.me/79094078581?text= "
          class="contact-btn whatsapp"
          target="_blank"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp"
            class="btn-icon"
          />
          Написать в WhatsApp
        </a>

        <!-- Телефонный блок -->
        <div class="phone-block">
          <a
            href="tel:79094078581"
            class="contact-btn phone"
            :class="{ 'mobile-only': !isMobile }"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/126/126341.png"
              alt="Телефон"
              class="btn-icon"
            />
            Позвонить
          </a>

          <div class="desktop-phone"
               v-if="!isMobile">
            <div class="phone-number">+7 (909) 407-85-81</div>
            <button
              class="copy-btn"
              @click="copyPhoneNumber"
              :class="{ 'copied': isCopied }"
            >
              {{ isCopied ? 'Скопировано!' : 'Копировать номер' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SellApartmentPage',
  data () {
    return {
      isMobile: false,
      isCopied: false
    }
  },
  mounted () {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile () {
      this.isMobile = window.matchMedia('(max-width: 768px)').matches
    },
    copyPhoneNumber () {
      navigator.clipboard.writeText('79094078581')
        .then(() => {
          this.isCopied = true
          setTimeout(() => {
            this.isCopied = false
          }, 2000)
        })
        .catch(() => {
          alert('Не удалось скопировать номер')
        })
    }
  }
}
</script>

<style scoped>
  .sell-apartment-page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 40px 20px;
    background-color: #f8f9fa;
  }
  .content {
    width: 100%;
    max-width: 500px;
    text-align: center;
    padding: 40px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }
  .title {
    font-size: 28px;
    margin-bottom: 12px;
    color: #2c3e50;
    font-weight: 600;
  }
  .subtitle {
    font-size: 16px;
    color: #7f8c8d;
    margin-bottom: 32px;
  }
  .contacts {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .contact-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px 24px;
    border-radius: 12px;
    text-decoration: none;
    font-weight: 500;
    font-size: 16px;
    transition: all 0.3s ease;
  }
  .contact-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .whatsapp {
    background: #25D366;
    color: white;
  }
  .phone {
    background: linear-gradient(180deg, #006B8D 0%, #1EA2CC 100%);
    color: white;
  }
  .btn-icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }
  .phone-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .desktop-phone {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;
  }
  .phone-number {
    padding: 12px;
    background: #f5f5f5;
    border-radius: 8px;
    font-size: 18px;
    color: #2c3e50;
  }
  .copy-btn {
    padding: 8px 12px;
    background: #e0e0e0;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .copy-btn:hover {
    background: #d0d0d0;
  }
  .copy-btn.copied {
    background: #4CAF50;
    color: white;
  }
  .mobile-only {
    display: none;
  }
  @media (max-width: 768px) {
    .mobile-only {
      display: flex;
    }
    .desktop-phone {
      display: none;
    }
    .content {
      padding: 30px 20px;
    }
    .title {
      font-size: 24px;
    }
    .contact-btn {
      padding: 12px 20px;
    }
  }
  @media (max-width: 480px) {
    .content {
      padding: 24px 16px;
      border-radius: 12px;
    }
    .title {
      font-size: 22px;
    }
    .subtitle {
      font-size: 14px;
    }
    .btn-icon {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
</style>
